import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { ContactCTA } from "../components/sections/ContactCTA";
import { SERVICES } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export default function ServicePage() {
  const { t } = useLang();
  const { slug } = useParams();
  const item = SERVICES.items.find((s) => s.slug === slug);

  if (!item) return <Navigate to="/services" replace />;

  return (
    <>
      <PageHero overline={t(SERVICES.overline)} title={t(item.name)} subtitle={t(item.desc)} />
      <section data-testid="service-detail-section" className="relative py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Reveal>
            <span className="font-mono text-xs tracking-[0.28em] uppercase text-[#60A5FA]">
              {t({ en: "What this can include", no: "Hva dette kan inkludere" })}
            </span>
          </Reveal>
          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            {item.examples.map((ex, i) => (
              <Reveal key={i} delay={(i % 4) * 0.06}>
                <div
                  data-testid={`service-example-${i}`}
                  className="flex items-center gap-3 rounded-xl border border-white/[0.07] bg-[#0A0E17] px-5 py-4"
                >
                  <Check className="h-4 w-4 shrink-0 text-[#60A5FA]" />
                  <span className="text-white/75">{t(ex)}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
